import { render, staticRenderFns } from "./UserViewUserInfoCard.vue?vue&type=template&id=b2d3254c&scoped=true&"
import script from "./UserViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./UserViewUserInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./UserViewUserInfoCard.vue?vue&type=style&index=0&id=b2d3254c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d3254c",
  null
  
)

export default component.exports